<div class="jepto-donut-chart-wrapper">
	<div class="jepto-donut-chart-plot">
		<div #chartContainer class="jepto-donut-chart-container"></div>
		@if (htmlCenterLabel(); as label) {
			<div class="center-label" aria-hidden="true">
				<div class="center-title">{{ label.title }}</div>
				@if (label.subtitle) {
					<div class="center-subtitle">{{ label.subtitle }}</div>
				}
			</div>
		}
	</div>
	@if (useSideLegend()) {
		<ul class="jepto-donut-chart__legend" aria-hidden="true">
			@for (item of sideLegendItems(); track item.name) {
				<li class="jepto-donut-chart__legend-item">
					<span
						class="jepto-donut-chart__legend-swatch"
						[style.background-color]="item.color"
					></span>
					<span class="jepto-donut-chart__legend-label">{{
						item.name
					}}</span>
				</li>
			}
		</ul>
	}
</div>
